import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    timezone: String,
  }

  connect() {
    this.timeout = null
    this.scheduleRefresh()
  }

  disconnect() {
    this.clearTimeout()
  }

  scheduleRefresh() {
    const msUntilMidnight = this.calculateMsUntilMidnight()

    if (msUntilMidnight > 0) {
      this.timeout = setTimeout(() => {
        window.location.reload()
      }, msUntilMidnight)
    }
  }

  calculateMsUntilMidnight() {
    const now = new Date()

    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: this.timezoneValue,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    })

    const parts = formatter.formatToParts(now)
    const getPart = (type) => parts.find((p) => p.type === type)?.value

    const hour = parseInt(getPart('hour'), 10)
    const minute = parseInt(getPart('minute'), 10)
    const second = parseInt(getPart('second'), 10)

    const secondsUntilMidnight =
      (24 - hour - 1) * 3600 + (60 - minute - 1) * 60 + (60 - second)

    return secondsUntilMidnight * 1000
  }

  clearTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  }
}
